export default __webpack_public_path__ + "static/media/slide2.2db48f92.jpg";